module.exports = require('scryptsy')



//////////////////
// WEBPACK FOOTER
// ./~/scrypt.js/js.js
// module id = 1736
// module chunks = 0 1 2